/** Main site (/) — travel agency home page (same number as nodextravel.com) */
export const MAIN_PHONE_TEL = '+18884014158';
export const MAIN_PHONE_DISPLAY = '1-888-401-4158';

/** Explore page (/explore) — travel concierge */
export const EXPLORE_PHONE_TEL = '+18335976924';
export const EXPLORE_PHONE_DISPLAY = '1-833-597-6924';

/** Cruise page (/cruises) — cruise concierge */
export const CRUISE_PHONE_TEL = '+18884014158';
export const CRUISE_PHONE_DISPLAY = '1-888-401-4158';

/** Flight page (/flight) — FareNodex-style flight booking */
export const FLIGHT_PHONE_TEL = '+18884014158';
export const FLIGHT_PHONE_DISPLAY = '1-888-401-4158';

/** @deprecated Use EXPLORE_PHONE_* on explore; MAIN_PHONE_* on main site */
export const PHONE_TEL = EXPLORE_PHONE_TEL;
export const PHONE_DISPLAY = EXPLORE_PHONE_DISPLAY;
